import React, { Component } from 'react';
import {NavLink, Link} from 'react-router-dom';


class Footer extends Component {
    constructor(props) {
        super(props);



         this.state={
           access_token:this.props.admin_token,
           user_details:this.props.admin_details,
           loading:true,
           loaded_successfully:false,
           api_error_message:"",
           server_changes_made:"",

         }
      }


  render() {
    return (

        <footer className="footer">
            <div className="container-fluid">
                <div className="copyright float-left">
                    ©
                    2019  <Link to="https://tuc.ac.ke" target="_blank">TURKANA UNIVERSITY COLLEGE</Link>
                </div>


            </div>
        </footer>



    );
  }
}

export default Footer;
